import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "nav-item"
};
const _hoisted_2 = ["href"];
const _hoisted_3 = {
  class: "sidenav-mini-icon"
};
const _hoisted_4 = {
  class: "sidenav-normal"
};
const _hoisted_5 = {
  class: "nav nav-sm flex-column"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("li", _hoisted_1, [_createElementVNode("a", {
    class: "nav-link",
    "data-bs-toggle": "collapse",
    "aria-expanded": "false",
    href: `#${$props.refer}`,
    onClick: _cache[0] || (_cache[0] = $event => $data.isExpanded = !$data.isExpanded)
  }, [_createElementVNode("span", _hoisted_3, _toDisplayString($props.miniIcon), 1), _createElementVNode("span", _hoisted_4, [_createTextVNode(_toDisplayString($props.text) + " ", 1), _cache[1] || (_cache[1] = _createElementVNode("b", {
    class: "caret"
  }, null, -1))])], 8, _hoisted_2), _createElementVNode("div", {
    class: _normalizeClass($data.isExpanded ? 'collapse show' : 'collapse')
  }, [_createElementVNode("ul", _hoisted_5, [_renderSlot(_ctx.$slots, "nav-child-item")])], 2)]);
}